import { impersonationConstant } from '../constants';

const TZ_OFFSET_RE = /[+-]\d{2}:?\d{2}$/;

const normalizeExpiresAt = (value) => {
    if (!value || typeof value !== 'string') return value || null;
    if (value.endsWith('Z') || value.endsWith('z')) return value;
    if (TZ_OFFSET_RE.test(value)) return value;
    return `${value}Z`;
};

const readInitialState = () => {
    try {
        const raw = localStorage.getItem('impersonation');
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed?.expiresAt) parsed.expiresAt = normalizeExpiresAt(parsed.expiresAt);
        return parsed;
    } catch {
        return null;
    }
};

const stored = readInitialState();

const buildState = (active, payload) => ({
    active,
    sessionToken: payload?.sessionToken || null,
    expiresAt: payload?.expiresAt || null,
    impersonatedByUserId: payload?.impersonatedByUserId ?? null,
    impersonatedByUserName: payload?.impersonatedByUserName || null,
    targetUserId: payload?.targetUserId ?? null,
    targetUserName: payload?.targetUserName || null,
    isReadOnly: payload?.isReadOnly !== false,
    originContext: payload?.originContext || null,
});

const initialState = buildState(!!stored, stored);

const impersonationReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case impersonationConstant.IMPERSONATION_START:
        case impersonationConstant.IMPERSONATION_HYDRATE:
            return buildState(true, payload);
        case impersonationConstant.IMPERSONATION_END:
            return buildState(false, null);
        default:
            return state;
    }
};

export default impersonationReducer;
